
import { QuestionBase, QuestionBaseParams, QuestionUITypes, QuestionVisiblityOperation, QuestionVisiblityOperators } from './question-base';


export class DropdownQuestionBoolean extends QuestionBase<boolean> {
  public questionType: QuestionUITypes = QuestionUITypes.BOOLEAN;
  public options: Array<{value: string, label: string}>;

  constructor(questionParams : QuestionBaseParams<boolean>) {
    super(questionParams);
    this.options = [
      { value: 'false', label : "Nein"  },
      { value: 'true', label : "Ja"  },      
    ];
  }

  public getValueForRequest() : boolean{
    return this.getAvailableValue() === 'true';
  }

  protected isVisible(operation : QuestionVisiblityOperation) : boolean{
    let result : boolean;

    if( operation.value !== 'true' && operation.value !== 'false' ){
      console.error( 'bad here' );
    }

    return this.getLiveValue() === operation.value;
  }

}



// WEBPACK FOOTER //
// ./src/app/question-dropdown-boolean.ts